import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { useRoute } from 'vue-router'
import { useDisplay } from 'vuetify';

export default /*#__PURE__*/_defineComponent({
  __name: 'AppHeader',
  setup(__props) {

const route = useRoute();
const { xs, smAndUp } = useDisplay();

return (_ctx: any,_cache: any) => {
  const _component_v_app_bar_title = _resolveComponent("v-app-bar-title")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!

  return (_openBlock(), _createBlock(_component_v_app_bar, {
    color: "primary",
    height: "auto",
    style: {"position":"fixed","top":"0","width":"100%","z-index":"1000"},
    "scroll-behavior": "hide"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_container, { fluid: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, { class: "mx-n4 mt-n4" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_app_bar_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Vanglateenistus")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, { class: "bg-white mx-n4 mb-n4" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_app_bar_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Kriminaalhooldusportaal")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                class: "pa-0 d-flex",
                style: {"min-height":"32px"},
                cols: "12",
                sm: "auto"
              }, {
                default: _withCtx(() => [
                  (_unref(smAndUp))
                    ? (_openBlock(), _createBlock(_component_v_spacer, { key: 0 }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_tabs, {
                    class: "elevation-5",
                    height: "100%",
                    "v-model": _unref(route).path,
                    "selected-class": "bg-primary",
                    "hide-slider": "",
                    grow: _unref(xs)
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_tab, {
                        to: "/",
                        exact: ""
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("AVALEHT")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_tab, {
                        to: "/ligipaasetavus",
                        exact: ""
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Ligipääsetavus")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["v-model", "grow"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})